import './DocumentTabRoutes.scss';
import React, { FC, useRef } from 'react';
import DevExpressTreeListDynamic from '@atoms/DevExpress/TreeList/DevExpressTreeListDynamic';
import Box from '@atoms/Box';
import { DocumentRoutesService } from '@services/DocumentRoutesService';
import { DataGridStateService } from '@services/DataGridStateService';
import { ProcessActionsService } from '@services/actions/ProcessActionsService';
import { DropdownContainerContext } from '@/context/Contexts';
import ScrollToTop from '@atoms/ScrollToTop/ScrollToTop';

export interface IDocumentTabRoutesProps {
    /** ИД документа */
    docId: string;
}

const DocumentTabRoutes: FC<IDocumentTabRoutesProps> = ({ docId }: IDocumentTabRoutesProps) => {
    const serviceGrid = new DocumentRoutesService();
    const stateService = new DataGridStateService();
    const actionsService = new ProcessActionsService();
    const tabRef = useRef<HTMLDivElement>(null);

    return (
        <DropdownContainerContext value={tabRef}>
            <div className="routes-tab" ref={tabRef}>
                <ScrollToTop scrollElementRef={tabRef} behavior={'smooth'} />
                <Box header="Маршруты">
                    <div className="routes-table">
                        <DevExpressTreeListDynamic
                            key="grid_routes"
                            stateService={stateService}
                            dataKey={docId}
                            gridKey="routes"
                            service={serviceGrid}
                            actionService={actionsService}
                        />
                    </div>
                </Box>
            </div>
        </DropdownContainerContext>
    );
};

export default DocumentTabRoutes;
